import React from 'react';
import type { FC } from 'react';

import { YouTubePlayer } from '@shared/you_tube_player';

import { BaseCard } from './base_card';

export const InstantDreamHomeCard: FC = () => (
  <BaseCard
    heading="Instant Dream Home"
    subheading="The Exclusive moving & storage partner of Netflix’s hit show"
    container="instant_dream_home"
    media={
      <YouTubePlayer
        title="Instant Dream Home | Official Trailer | Netflix"
        videoID="XyJRl54zJdU"
        wtConfig={{
          objectName: 'instant_dream_home_trailer',
        }}
      />
    }
    body={
      <>
        The hit new Netflix show, Instant Dream Home, relies on Clutter and our
        industry-leading Move & Pack team to make the impossible possible as
        they tackled ambitious, full-home renovations for deserving families
        &ndash; in under 12 hours! Book with our team.
      </>
    }
  />
);
